var exports = {
  "k": "container__qnX6sL",
  "W": "area__cYPRPP",
};

module.exports = exports;
